import assetPath from '/app/packages/lebenslauf/articles/src/assets/faehigkeiten-lebenslauf.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')